import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { forgetUser, resetProfile } from '../../utils/api'; // Adjust path as needed

/**
 * This component displays a confirmation modal for account deletion.
 */
function DeleteAccountComponent({ handleError }) {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const [isProcessing, setIsProcessing] = useState(false);

  // Handler for when the user confirms the deletion
  const handleConfirmDelete = async () => {
    setIsProcessing(true);
    try {
      const data = await forgetUser();

      // Check for the custom status property from your backend
      if (data && data.status === 'user_deleted') {
        // On success, clear session data and log the user out.
        resetProfile();
        logout({
          logoutParams: {
            returnTo: window.location.origin
          }
        });
      } else {
        // Handle cases where the API call succeeded but didn't confirm deletion
        throw new Error('Deletion could not be confirmed. Please try again.');
      }
    } catch (e) {
      // Use the app's global error handler
      handleError(e);
      setIsProcessing(false);
    }
  };

  // Handler for when the user cancels
  const handleCancel = () => {
    navigate('/'); // Redirect to the homepage or another safe page
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
      justifyContent: 'center', alignItems: 'center', zIndex: 1000
    }}>
      <div style={{
        background: 'white', padding: '30px 40px', borderRadius: '8px',
        textAlign: 'center', boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
        maxWidth: '400px'
      }}>
        <h2 style={{ marginTop: 0, color: '#333' }}>Are you sure?</h2>
        <p style={{ color: '#666', lineHeight: 1.6 }}>
          This will permanently delete your account and all associated data.
          This action cannot be undone.
        </p>
        <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '15px' }}>
          <button
            onClick={handleCancel}
            disabled={isProcessing}
            style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '5px', background: '#f0f0f0' }}
          >
            No, take me back
          </button>
          <button
            onClick={handleConfirmDelete}
            disabled={isProcessing}
            style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer', border: 'none', borderRadius: '5px', background: '#dc3545', color: 'white' }}
          >
            {isProcessing ? 'Processing...' : 'Yes, delete it'}
          </button>
        </div>
      </div>
    </div>
  );
}

// Wrap with withAuthenticationRequired to protect this page
export default withAuthenticationRequired(DeleteAccountComponent);